import { call, put } from 'redux-saga/effects';
import { api, notify } from 'services';
import { IUpdateRequest } from 'interfaces/update-duck';
import { requestErrorHandler } from 'utils';
import { AlterPickingActions } from 'store/ducks/pickings';

export function* alterPickingRequest(action: any) {
  try {
    const { id, putData, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      api.put,
      `/picking/alter/${id}`,
      putData
    );

    const { data } = responseBody;
    yield put(AlterPickingActions.success(data));
    notify('success', 'Picking alterado com sucesso');
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify('error', errorMessage);
    yield put(AlterPickingActions.failure(errorMessage));
  }
}
